import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Domicilio, Persona, Poliza, Riesgo } from '../../model/poliza.model';
import { DatosProyectoComponent } from '../datos-proyecto/datos-proyecto.component';
import { DatosPersonalesComponent } from '../datos-personales/datos-personales.component';
import { CaCardComponent } from '@global-front-components/ui/card';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { DatosDomicilioConfig, DatosPersonalesConfig, ModoEdicion } from '../../../ui/model/catalogo-config.model';
import { DatosDomicilioComponent } from '../datos-domicilio/datos-domicilio.component';
import { PolizaStoreService } from '../../services/store/poliza-store.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CaIcon } from '@global-front-components/ui/form-field';
import { CatalogoSvgStoreService } from '../../services/store/catalogo-svg-store.service';
import { IdiomaCatalogo } from '../../model/catalogo.model';
import { IdiomasComponent } from '../idiomas/idiomas.component';
import { PolizaApiService } from '../../services/api/poliza-api.service';
import { GlobalMessageHandlerService } from '../../services/util/global-message-handler.service';
import { Router } from '@angular/router';
import { FlujoPolizaNavigationComponent } from '../base/flujo-poliza-navigation.component';
import { EnvioEmailComponent } from '../envio-email/envio-email.component';
import { CaRadioButtonComponent, CaRadioGroupDirective } from '@global-front-components/ui/radio-button';

@Component({
	selector: 'app-guardar-proyecto',
	standalone: true,
	imports: [
		CommonModule,
		DatosProyectoComponent,
		DatosPersonalesComponent,
		DatosDomicilioComponent,
		CaCardComponent,
		CaButtonComponent,
		CaIcon,
		ReactiveFormsModule,
		TranslateModule,
		IdiomasComponent,
		CaRadioButtonComponent,
		CaRadioGroupDirective,
		EnvioEmailComponent
	],
	templateUrl: './guardar-proyecto.component.html',
	styleUrls: ['./guardar-proyecto.component.scss']
})
export class GuardarProyectoComponent extends FlujoPolizaNavigationComponent implements OnInit{
	guardarForm!: FormGroup;
	propuesta!: Poliza<Riesgo>;
	propuestaGuardada!: Poliza<Riesgo>;
	tomadorConfig: DatosPersonalesConfig;
	domicilioTomadorConfig: DatosDomicilioConfig;
	idiomas: IdiomaCatalogo[] = [];
	mostrarEnvioEmail = false;

	constructor(
		router: Router,
		polizaStore: PolizaStoreService,
		catalogoSvgStore: CatalogoSvgStoreService,
		private fb: FormBuilder,
		private polizaApiService: PolizaApiService,
		private translateService: TranslateService,
		private globalMessageHandler: GlobalMessageHandlerService
	) { 
		super(router, polizaStore, catalogoSvgStore);
	}

	ngOnInit(): void {

		this.catalogoSvgStore.catalogoProtocoloSubject$.subscribe((catalogo) => {
			if (catalogo) {
				this.idiomas = catalogo.idiomas;
			}
		});
		
		this.guardarForm = this.fb.group({
			datosProyecto: this.fb.group({}),
			datosPersonalesTomador: this.fb.group({}),
			datosDomicilioTomador: this.fb.group({}),
			datosIdiomas: this.fb.group({})
		});
		this.polizaStore.polizaSubject$.subscribe((propuesta: Poliza<Riesgo>) => {
			if (propuesta) {
				this.propuesta = propuesta;
				this.tomadorConfig = {
					persona: this.propuesta?.tomador || {},
					rol: 'tomador',
					modoEdicion: ModoEdicion.VALORES,
					mostrarDocumento: true,
					mostrarNombre: true,
					mostrarFechaNacimiento: false,
					mostrarSexo: false
				}
				this.domicilioTomadorConfig = {
					domicilio: this.propuesta?.tomador?.domicilio || {},
					rol: 'tomador',
					modoEdicion: ModoEdicion.VALORES,
					mostrarVia: true,
					mostrarLocalidad: true,
					mostrarProvincia: true
				};
			}
		});
	}

	guardarProyecto(imprimir?: boolean): void {
		let propuestaGuardar = this.propuesta;
		this.completarProyecto(propuestaGuardar);
		this.polizaApiService.guardarPropuesta(propuestaGuardar).subscribe({
			next: (propuestaGuardada: Poliza<Riesgo>) => {
				if (propuestaGuardada?.codigoPropuesta){
					this.propuestaGuardada = propuestaGuardada;
					this.globalMessageHandler.emitSuccess(this.translateService.instant('GUARDAR_PROYECTO.PROPUESTA_GUARDADA', 
						{ codigoPropuesta: this.propuestaGuardada.codigoPropuesta }));
					if (imprimir){
						this.polizaApiService.imprimirPoliza(propuestaGuardada.codigoPropuesta, Number(propuestaGuardar.codigoProducto), propuestaGuardar.codigoIdioma, true)
						.subscribe((url: string) => {
							if (url) {
								window.open(url, '_blank');
							}
						});
					}
				}
			}
		});
	}

	completarProyecto(propuesta: Poliza<Riesgo>): void {
		const nombreProyecto = this.guardarForm.get('datosProyecto.nombreProyecto')?.value;
		const codIdioma = this.guardarForm.get('datosIdiomas.codIdioma')?.value;
		//this.propuesta.nombreProyecto = nombreProyecto;
		propuesta.codigoIdioma = codIdioma;
	}

	public onTomadorChange(persona: Persona): void {
		this.propuesta.tomador = persona;
	}

	public onDomicilioTomadorChange(domicilio: Domicilio): void {
		this.propuesta.tomador.domicilio = domicilio;
	}

	cambioEnvioEmail(evento: any) {
		if (evento?.value === "1") {
			this.mostrarEnvioEmail = true;
			this.guardarForm.addControl('envioEmail',this.fb.group({}));
		} else {
			this.mostrarEnvioEmail = false;
			this.guardarForm.removeControl('envioEmail');
		}
	}
}
